import { Button, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { usePutProductTypeMutation } from "../../../../backoffice/apis/productTypeAPI";
import ProductType, { getEmptyProductType, validateProductType } from "../../../../backoffice/dtos/products/productType";
import { useTranslation } from "react-i18next";
import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";

export default function ProductTypeSettingsModal(
    {
        isOpen,
        toggle,
        productType: currentProductType
    }: {
        isOpen: boolean,
        toggle: () => void,
        productType: ProductType
    }
) {
    const { t } = useTranslation(['products', 'common']);
    const [saveProductType] = usePutProductTypeMutation();
    const [productType, setProductType] = useState<ProductType>(getEmptyProductType());
    const [formErrors, setFormErrors] = useState<Map<string, string>>();

    useEffect(() => {
        setProductType(currentProductType)
    }, [currentProductType])

    const updateCustomer = useCallback(async () => {
        try {
            saveProductType(productType).unwrap();
            toast(t('Successfully updated product type'))
            toggle()
        } catch (e: any) {
            toast(e.data.message)
        }
    }, [productType])

    const handleUpdate = useCallback(async () => {
        const errors = validateProductType(productType)
        setFormErrors(errors);

        if (Object.entries(errors).length === 0) {
            await updateCustomer()
        }
    }, [updateCustomer, productType])

    const confirmUpdate = useCallback(() => {
        confirmAlert({
            title: t('Update product type'),
            message: t("Are you certain for the product type's update?", { productType: productType.description }),
            buttons: [{ label: t('yes', { ns: 'common' }), onClick: handleUpdate }, { label: t('no', { ns: 'common' }) }]
        })
    }, [handleUpdate, productType])


    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>
                {t('edit', { ns: 'common' })}
            </ModalHeader>
            <ModalBody>
                <Label>{t('Description', { ns: 'common' })}</Label>
                <Input
                    value={productType.description}
                    disabled={true}
                />
                <p style={{ color: 'red' }}>{formErrors?.get("description")}</p>
                <Label>{t('Order Number', { ns: 'common' })}</Label>
                <Input type="text"
                    placeholder={productType.orderNumber}
                    value={productType.orderNumber}
                    onChange={(e) => setProductType({ ...productType, orderNumber: e.target.value })}
                />
                <p style={{ color: 'red' }}>{formErrors?.get("orderNumber")}</p>
            </ModalBody>

            <ModalFooter>
                <Button color="success" onClick={confirmUpdate}>
                    {t('update', { ns: 'common' })}
                </Button>
            </ModalFooter>
        </Modal>
    )
}